import * as React from "react";
import { SVGProps } from "react";
const SvgInvestmentPlan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M6 18v-6h3v6H6Zm4.5 0V6h3v12h-3Zm4.5 0V9.75h3V18h-3Z"
      fill="#fff"
    />
  </svg>
);
export default SvgInvestmentPlan;
